import { TextColor } from '@setvi/shared/enums';
import { Product } from '@setvi/shared/interfaces';
import { ModifiableProduct } from '../subpages/orders/subpages/order-create';

export const GPCalcPercentage = (sell: number, cost: number): number => {
  if (!cost && !sell) {
    return 0;
  }

  if (cost === 0) {
    return 100;
  }

  if (sell === 0) {
    return -100;
  }

  return ((sell - cost) / sell) * 100 || 0;
};

export const GPValueCalc = (sell: number, cost: number): number => {
  if (!cost && !sell) {
    return 0;
  }

  if (cost === 0) {
    return sell;
  }

  if (sell === 0) {
    return -cost;
  }

  return sell && cost ? sell - cost : 0;
};

export const getGPFontColor = (GP: number): TextColor => {
  if (GP < 0) {
    return TextColor.Red;
  }
  if (GP === 0) {
    return TextColor.Black;
  }
  return TextColor.Green;
};

export const getProductSellAndMargin = (
  product: Product
): Pick<
  ModifiableProduct,
  'sell' | 'profitMarginCurrency' | 'profitMarginPercent'
> => {
  const sell = product.price || 0;
  const profitMarginPercent =
    product?.price && product?.cost
      ? parseFloat(
          (((product.price - product.cost) / product.price) * 100).toFixed(2)
        )
      : 0;
  const profitMarginCurrency =
    product?.price && product.cost
      ? parseFloat((product.price - product.cost).toFixed(2))
      : 0;

  return { sell, profitMarginCurrency, profitMarginPercent };
};
